import request from '@/utils/request'
export function login(params) {
  return request({
    url: 'oauth/login',
    method: 'post',
    params: params
  })
}
export function getUserInfo(params) {
  return request({
    url: 'system/wechatUser/userInfo',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js